import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=20e560bc&scoped=true&"
import script from "./Starter.vue?vue&type=script&lang=js&"
export * from "./Starter.vue?vue&type=script&lang=js&"
import style0 from "./Starter.vue?vue&type=style&index=0&id=20e560bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e560bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VIcon,VSimpleTable})
